import SplitText from "../utilities/splitText";

export default {
    name: 'text',
    component() {
        return {
            elements: [],
            elementsVisible: [],
            
            init() {
                
                setTimeout(() => {
                    this.elements = document.querySelectorAll("h1, h2, h3");
                    if (this.splittedText) {
                        this.splittedText.revert();
                    }
            
                    this.splittedText = new SplitText(this.elements, {
                        type: "lines",
                    });
            
                    this.elements.forEach((el) => {
                        [...el.children].forEach((child) => {
                            this.wrap(child);
                        });
                        // el.style.opacity = 1;
                    });
                }, 200);
        


                setTimeout(() => {
                    this.elementsVisible = document.querySelectorAll(
                        "[data-visible], [data-split], h1, h2, h3"
                    );
                }, 200);

                setTimeout(() => {
                    this.checkVisibility();
                }, 200);
            },
        
            wrap(toWrap, wrapper) {
                wrapper = wrapper || document.createElement("div");
                toWrap.parentNode.appendChild(wrapper);
                return wrapper.appendChild(toWrap);
            },

            checkVisibility() {
                if ("IntersectionObserver" in window) {
                    let options = {
                        threshold: window.innerWidth <= 1000 ? 0.35 : 0.45,
                    };
        
                    let elObserver = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            let el = entry.target;
                            if (entry.isIntersecting) {
                                el.classList.add("is-visible");
                                // elObserver.unobserve(el);
                            }
                            // } else {
                            //     el.classList.remove("is-visible");
                            // }
                        });
                    }, options);
        
                    this.elementsVisible.forEach((el) => {
                        elObserver.observe(el);
                    });
                } else {
                    this.elementsVisible.forEach((el) => {
                        el.classList.add("is-visible");
                    });
                }
            },
        }
    }
};
